// 4-up stat row inside a flush kpanel on /voice-profile. V1 cut from the
// kit's 8-stat grid (sentence length, question rate, backchannel, pause
// length need new analysis-side metrics; defer to v2).

export type Stat = {
  label: string;
  value: string;
  unit?: string;
  sub?: string;
};

export function StatGrid({ stats }: { stats: Stat[] }) {
  return (
    <div className="kpanel flush" style={{ marginBottom: 14 }}>
      <div className="stat-grid">
        {stats.map((s) => (
          <div key={s.label} className="stat">
            <span className="l">{s.label}</span>
            <span className="v">
              {s.value}
              {s.unit ? <small>{s.unit}</small> : null}
            </span>
            {s.sub ? <span className="sub">{s.sub}</span> : null}
          </div>
        ))}
      </div>
    </div>
  );
}
